import { render, staticRenderFns } from "./LivePlay.vue?vue&type=template&id=53560810&scoped=true&"
import script from "./LivePlay.vue?vue&type=script&lang=js&"
export * from "./LivePlay.vue?vue&type=script&lang=js&"
import style0 from "./LivePlay.vue?vue&type=style&index=0&id=53560810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53560810",
  null
  
)

export default component.exports